__turbopack_context__.v({
  "bar": "index-module-scss-module__WR5Wdq__bar",
  "hide": "index-module-scss-module__WR5Wdq__hide",
  "init": "index-module-scss-module__WR5Wdq__init",
  "lottie": "index-module-scss-module__WR5Wdq__lottie",
  "splash": "index-module-scss-module__WR5Wdq__splash",
  "text": "index-module-scss-module__WR5Wdq__text",
});
